import { Component, OnInit } from '@angular/core';
import { VerificationComponent } from '../verification/verification.component';
import { ModalController, LoadingController, IonInfiniteScroll, ToastController } from '@ionic/angular';

@Component({
  selector: 'app-forget-password',
  templateUrl: './forget-password.component.html',
  styleUrls: ['./forget-password.component.scss'],
})
export class ForgetPasswordComponent implements OnInit {

  constructor(public modalController: ModalController) { }

  correo = '';

  ngOnInit() {}
// Go to product details page
async verificar() {
  // console.log(codigoP);
  const modal = await this.modalController.create({
    component: VerificationComponent,
    componentProps: { email: this.correo }
  });
  return await modal.present();
}
}
